module.exports = __webpack_public_path__ + "media/components/smartbar/static/smartbanner-icon-f9f231199dd86b7914066cff547cdb87.png";